import React from 'react';
import { storiesOf } from '@storybook/react';
import RefineSearch from './RefineSearch';

storiesOf('Advanced Search', module).add('RefineSearch', () => (
  <RefineSearch advancedSearchFilter={advancedSearchFilter} facets={facets} onSearchAdvancedFilings={() => null} />
));

const advancedSearchFilter = {
  case_titles: 'include',
  court_type: 'all',
  do_search: true,
  grouped: true,
  keys: 'lehman',
  my_cases: '',
  page: 0,
  party_name: 'include',
  query: null,
  search_pdfs: 'exclude',
  tab: 'cases',
  template: 'case_lookup',
};

const facets = {
  chapter: {
    10: 2,
  },
  court: {
    randomCourt: 3,
  },
  court_type: {
    bankruptcy: 20,
  },
  date_filed: { 2008: 1 },
  judge_name: { 'Leonardo diCaprio': 1 },
};



// WEBPACK FOOTER //
// ./src/components/refineSearch/RefineSearch.stories.jsx